var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.transparent)?_c('div',[_vm._t("default")],2):_c('div',{class:_vm.$style['input-group']},[(_vm.label)?_c('h4',{class:_vm.$style['input-group__label']},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e(),_c('div',{class:[
			_vm.$style['input-group__content'],
			_vm.mobileBreak && _vm.$style['input-group__content--break']
		]},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }